import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { BuildifyContent, BuildifyContentKey } from '../entities/BuildifyContent.js';

export const getBuildifyContent = registerQuery({
  operationName: 'getBuildifyContent',

  params: [{ name: 'key', type: () => BuildifyContentKey }],
  type: () => BuildifyContent,
  resolve: (key: BuildifyContentKey) => async gqlFields => {
    const query = { key: key.toJSON() };
    const data = await loadMongoData(BuildifyContent, query).then(docs => docs?.[0]);
    if (data) return data as BuildifyContent;
    return new BuildifyContent({ key, html: '' });
  },
});
